import React from "react";
export function SiteFooter() {
  return <footer className="bg-[#06122B] px-4 pb-32 pt-12 text-center sm:pb-14" data-id="element-298" data-mp="3rjw0bkxgv4kv">
      <div className="mx-auto max-w-3xl" data-id="element-299" data-mp="1bdr21uylr230">
        <p className="text-lg font-extrabold tracking-tight text-white" data-id="element-300" data-mp="1bgwthgupeg1w">Hemodynamic Monitoring Blueprint™</p>
        <p className="mt-1 text-sm text-brand-sky" data-id="element-301" data-mp="1kfrwkk2gba0z">Created by Rachel Bennett</p>
        <p className="mt-3 text-sm text-brand-sky" data-id="element-302" data-mp="1kdnum7o44l3c">
          A structured digital educational reference collection for hemodynamic monitoring and critical care nursing studies.
        </p>
        <p className="mt-8 text-xs leading-relaxed text-slate-400" data-id="element-303" data-mp="rrcoyilnftzo">
          <strong className="text-slate-300" data-id="element-304" data-mp="wp4lxr15i6aq">Educational disclaimer:</strong> This product is intended for educational and professional
          reference purposes only. It does not provide patient-specific medical advice, diagnose medical conditions, establish validated
          clinical decision algorithms, or replace professional judgment, current evidence, supervised clinical training, institutional
          protocols, or applicable professional guidelines.
        </p>
        <p className="mt-6 text-xs text-slate-400" data-id="element-305" data-mp="6l08pilk3ks8">© 2026 · All rights reserved.</p>
      </div>
    </footer>;
}